<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Nombre</th>
                <th :class="StyleTh">Clave</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

            <template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
					<td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                    <td><p :class="StyleTd">{{lista.Clave}}</p></td>                    
					<td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="false" :pShowBtnDelete="false" :pIsModal="true" :pId="lista.IdGrupolinea" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">
                                <button @click="viewArticulos(lista)" v-b-tooltip.hover.left title="Agregar Articulos" class="btn btn-primary btn-icon btn-sm rounded me-2">
                                    <i class="far fa-plus-circle"></i>
                                </button>
                            </template>
						</CBtnAccion>
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="4"></CSinRegistros>
			</template>
        </CList>
        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave" :pIdTipoLente="ObjTipoLente.IdTipoLente"></Form>
			</template>
		</CModal>
    </div>
</template>
<script>
import Configs from '@/helpers/VarConfig.js';
import Form from '../tiposlentesxsublineas/Form.vue';
const EmitEjecuta = 'seccionTiposLentesxSublineas';

export default{
    name:'TiposLentesxSublineas',
    props:['pObjEnviado'],
    components:{Form},
    data(){
        return{
            ConfigList:{
                Title: 'Listado de sublineas para: ',
                IsModal: true,
                ShowLoader: true,
                BtnReturnShow: true,
                EmitSeccion: EmitEjecuta,
                TitleFirst: '',
                ShowTitleFirst: false,
                BtnNewName:'Agregar'
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 10,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            ConfigModal:{
                ModalTitle: "Formulario Agregar Sublineas",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize:'xl'
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            ListaHeader: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ObjTipoLente:{}
        }
    },
    methods:{
        async Lista(){
            this.ConfigList.ShowLoader=true;
            await this.$http.get('tiposlentesxsublinea',{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdTipoLente: this.ObjTipoLente.IdTipoLente,
                }
            }).then((res)=>{
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Regresar(){
            this.$router.push({name:'tiposlentes',params:{}});
        },
        // AbrirModalNuevo(){
        //     this.bus.$emit('NewModal_'.this.ConfigList.EmitSeccion);
        // }
        viewArticulos(item){
            sessionStorage.setItem('OrigenMenu','Sublinea');
            this.$router.push({name:'articulosweb',params:{pObjTipoLente:this.ObjTipoLente,pObjSublinea:item}});
        }
    },
    created(){
        if(this.pObjEnviado != undefined){
            sessionStorage.setItem('objTipoLente',JSON.stringify(this.pObjEnviado));
        }
        this.ObjTipoLente = JSON.parse(sessionStorage.getItem('objTipoLente'));
        this.ConfigList.Title = this.ConfigList.Title+this.ObjTipoLente.Nombre;

        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted(){
        this.Lista();

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>